import React from 'react';

export const Mute = (props) => (
  <svg
    fill="none"
    height="38"
    viewBox="0 0 24 38"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      height="15"
      id="mask0"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      width="3"
      x="19"
      y="12"
    >
      <path
        d="M20.105 12.0176V21.4326C20.1009 21.5677 20.0927 21.8241 20.0723 22.1514C20.0382 22.6984 19.9836 23.2466 19.9086 23.754C19.7463 24.822 19.4871 25.5667 19.2539 25.7099L19.7927 26.5787C20.3887 26.2104 20.7106 25.2884 20.9192 23.9081C21.0011 23.3667 21.0584 22.7884 21.0925 22.2155C21.1143 21.8691 21.1252 21.599 21.1266 21.4422V12.0176H20.105Z"
        fill="#74729D"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M20.105 12.0176V21.4326C20.1009 21.5677 20.0927 21.8241 20.0723 22.1514C20.0382 22.6984 19.9836 23.2466 19.9086 23.754C19.7463 24.822 19.4871 25.5667 19.2539 25.7099L19.7927 26.5787C20.3887 26.2104 20.7106 25.2884 20.9192 23.9081C21.0011 23.3667 21.0584 22.7884 21.0925 22.2155C21.1143 21.8691 21.1252 21.599 21.1266 21.4422V12.0176H20.105Z"
        fill="#8D959C"
      />
    </g>
    <mask
      height="19"
      id="mask1"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      width="17"
      x="1"
      y="13"
    >
      <path
        d="M1.67871 13.6816V22.7912C1.67871 26.9989 4.97392 30.931 9.08201 31.6457C9.24432 31.7262 9.49937 31.7671 9.86762 31.808C10.3109 31.8544 10.9724 31.8912 11.9039 31.913C13.1096 31.8885 14.2949 31.602 15.4324 31.1397C15.847 30.9733 16.2289 30.7919 16.5671 30.6132C16.7717 30.5027 16.919 30.4141 17.0009 30.3636L16.4512 29.5003C16.3898 29.5385 16.2644 29.6135 16.083 29.7103C15.7761 29.8726 15.4283 30.0376 15.0478 30.1918C14.0166 30.6105 12.9487 30.8683 11.9053 30.8887C11.0583 30.871 10.4364 30.8383 10.0272 30.7932C10.034 30.7701 10.0395 30.7551 10.0395 30.7551L9.45027 30.6705C5.74589 30.1331 2.70301 26.5665 2.70301 22.7912V13.6816H1.67871Z"
        fill="#74729D"
      />
    </mask>
    <g mask="url(#mask1)">
      <path
        clipRule="evenodd"
        d="M-8.89258 42.4854H27.5743V3.10938H-8.89258V42.4854Z"
        fill="#8D959C"
        fillRule="evenodd"
      />
    </g>
    <path
      clipRule="evenodd"
      d="M11.5941 31.0664H11.0826H10.8276V31.3215V31.5765V36.1483H5.45102H5.19733H4.94092V36.4061V36.9189V37.174H5.19733H5.45102H10.8276V37.2067H11.0826H11.5941H11.8505V37.174H17.7358H17.9922H18.2486V36.9189V36.4061V36.1483H17.9922H17.7358H11.8505V31.5765V31.3215V31.0664H11.5941ZM11.0826 36.6612H11.3377H11.0826H5.45102H11.0826Z"
      fill="#8D959C"
      fillRule="evenodd"
    />
    <mask
      height="23"
      id="mask2"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      width="13"
      x="5"
      y="0"
    >
      <path
        d="M5.87549 4.52331C8.36735 8.56867 17.0091 22.4355 17.0091 22.4355C17.0091 22.4355 17.0132 11.2924 17.0132 5.77265C17.0118 1.10536 13.9048 0.246094 11.402 0.246094C8.90337 0.246094 5.8864 1.25129 5.87549 4.52331Z"
        fill="#74729D"
      />
    </mask>
    <g mask="url(#mask2)">
      <path
        clipRule="evenodd"
        d="M-4.69629 29.6818H27.5847V-13.6523H-4.69629V29.6818Z"
        fill="#8D959C"
        fillRule="evenodd"
      />
    </g>
    <mask
      height="17"
      id="mask3"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      width="11"
      x="5"
      y="12"
    >
      <path
        d="M5.77376 22.0547C5.59645 28.0709 11.048 28.2414 11.8213 28.2373C12.5947 28.2414 14.2996 28.0436 15.2011 27.3971C13.544 24.7812 5.77376 12.1445 5.77376 12.1445C5.77376 12.1445 5.77513 18.5754 5.77376 22.0547Z"
        fill="#74729D"
      />
    </mask>
    <g mask="url(#mask3)">
      <path
        clipRule="evenodd"
        d="M-4.80225 38.8097H25.7725V1.57227H-4.80225V38.8097Z"
        fill="#8D959C"
        fillRule="evenodd"
      />
    </g>
    <path
      clipRule="evenodd"
      d="M0.949219 1.5735L1.22064 2.00858L22.1007 35.423L22.3721 35.8567L23.241 35.3153L22.9682 34.8815L2.08808 1.46438L1.8153 1.0293L0.949219 1.5735Z"
      fill="#8D959C"
      fillRule="evenodd"
    />
  </svg>
);
